module.exports = __webpack_public_path__ + "img/clouds-with-littlerain.bfe42dee.png";